import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { BREAKPOINT } from '../../../../constants/styles';
import { getFieldProps } from '../../../../utils/fields/getFieldProps';
import EmergencyContactRowModeView from './EmergencyContactRowModeView';
import EmergencyContactColumnModeView from './EmergencyContactColumnModeView';

const EmergencyContactFormSection = ({
  onChange,
  formState,
  relationList,
  formatMessage,
  onEmailChange,
  validateErrors,
  onMobilePhoneChange,
}) => {
  const makeProfileField = getFieldProps(formatMessage, onChange);

  return (
    <Fragment>
      <MediaQuery maxWidth={BREAKPOINT}>
        <EmergencyContactColumnModeView
          onChange={onChange}
          formState={formState}
          relationList={relationList}
          formatMessage={formatMessage}
          onEmailChange={onEmailChange}
          validateErrors={validateErrors}
          makeProfileField={makeProfileField}
          onMobilePhoneChange={onMobilePhoneChange}
        />
      </MediaQuery>

      <MediaQuery minWidth={BREAKPOINT}>
        <EmergencyContactRowModeView
          onChange={onChange}
          formState={formState}
          relationList={relationList}
          formatMessage={formatMessage}
          onEmailChange={onEmailChange}
          validateErrors={validateErrors}
          makeProfileField={makeProfileField}
          onMobilePhoneChange={onMobilePhoneChange}
        />
      </MediaQuery>
    </Fragment>
  );
};

EmergencyContactFormSection.propTypes = {
  onChange: PropTypes.func,
  formState: PropTypes.object,
  relationList: PropTypes.array,
  formatMessage: PropTypes.func,
  onEmailChange: PropTypes.func,
  validateErrors: PropTypes.object,
  onMobilePhoneChange: PropTypes.func,
};

export default EmergencyContactFormSection;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/EmergencyContact/EmergencyContactFormSection/index.jsx